import React from "react";

function BS4_Exercises() {
  return (
    <div>
      <h1>BS4_Exercises Component</h1>
      <p>This is the BS4_Exercises tutorial page content.</p>
    </div>
  );
}

export default BS4_Exercises;
